export default __webpack_public_path__ + "static/media/demand.fd45bbc6.svg";